import React, { useEffect, useState } from "react";
import { useTable } from "../../Components/useTable";

const WithdrawRequestList = () => {
  const type = "Withdraw Request";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "amount", numeric: false, label: "Amount" },
    { id: "rcoin", numeric: false, label: "RCoin" },
    // { id: "description", numeric: false, label: "Description" },
    { id: "deductedTax", numeric: false, label: "Deduction Amount" },
    { id: "orderId", numeric: false, label: "Order ID" },
    { id: "userName", numeric: false, label: "UserName" },
    { id: "userCode", numeric: false, label: "RID" },
    { id: "pictureUrl", numeric: false, label: "User Image" },
    { id: "userEmail", numeric: false, label: "User Email" },
    {
      id: "user_payment_method_account",
      numeric: false,
      label: "User Account",
    },
    {
      id: "user_payment_method_paymentMethod_name",
      numeric: false,
      label: "Account name",
    },
    {
      id: "user_payment_method_paymentMethod_feePercentage",
      numeric: false,
      label: "percentage",
    },
    {
      id: "user_payment_method_paymentMethod_type",
      numeric: false,
      label: "type",
    },
    // { id: "merchantRID", numeric: false, label: "Merhcant RID" },
    // { id: "merchantUserName", numeric: false, label: "Merhcant UserName" },
    // { id: "merchantName", numeric: false, label: "Merhcant Name" },
    // { id: "Picture", numeric: false, label: "Merhcant Image" },
    { id: "created", numeric: false, label: "Date" },
    // { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default WithdrawRequestList;
